import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../Context/auth';
import MenuLateral from '../Components/MenuPrincipal/MenuLateral';
import UnidadeMedidaForm from '../Components/UnidadeMedidaForm/UnidadeMedidaForm';
import './UnidadeMedida.css';
import Swal from 'sweetalert2';

function EditarUnidadeMedida() {
    const { currentUser, appUserData } = useAuth();
    const navigate = useNavigate();
    const { id } = useParams();

    // Verifica permissão de edição
    useEffect(() => {
        if (appUserData && !appUserData['editar_unidades_medida']) {
            Swal.fire({
                icon: 'error',
                title: 'Acesso Negado',
                text: 'Você não tem permissão para editar unidades de medida.',
                confirmButtonColor: '#2185c6'
            }).then(() => {
                navigate('/app/home');
            });
        }
    }, [appUserData, navigate]);

    const [unidadeData, setUnidadeData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [mensagem, setMensagem] = useState('');
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        const fetchUnidadeMedida = async () => {
            if (!id || !currentUser) return;

            try {
                const token = await currentUser.getIdToken();
                const API_URL = process.env.REACT_APP_API_URL;
                const response = await fetch(`${API_URL}/api/unidadesmedida/${id}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });

                if (!response.ok) {
                    if (response.status === 404) setNotFound(true);
                    throw new Error("Unidade de medida não encontrada.");
                }

                const data = await response.json();
                setUnidadeData(data);
            } catch (error) {
                setMensagem(error.message);
                if (!notFound) {
                    setTimeout(() => navigate('/app/unidadesmedida'), 3000);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchUnidadeMedida();
    }, [id, currentUser, navigate, notFound]);

    const handleSubmit = async (dadosUnidade) => {
        setMensagem('');
        setSaving(true);
        try {
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;
            const response = await fetch(`${API_URL}/api/unidadesmedida/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(dadosUnidade)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Falha ao atualizar a unidade.');
            }

            navigate('/app/unidadesmedida');
        } catch (error) {
            console.error("Erro ao atualizar unidade de medida: ", error);
            setMensagem(error.message);
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <div className="unidade-page-container" style={{ display: 'flex', paddingTop: 0 }}>
                <MenuLateral />
                <div className="d-flex justify-content-center align-items-center w-100" style={{ height: '60vh' }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Carregando...</span>
                    </div>
                </div>
            </div>
        );
    }

    if (notFound) {
        return (
            <div className="unidade-page-container" style={{ display: 'flex', paddingTop: 0 }}>
                <MenuLateral />
                <div className="content-with-sidebar w-100">
                    <div className="text-center p-5">
                        <h3>Unidade não encontrada</h3>
                        <p>A unidade que você está tentando editar não existe ou foi removida.</p>
                        <button className="btn btn-primary-custom" onClick={() => navigate('/app/unidadesmedida')}>
                            Voltar para a lista
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="unidade-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />
            <div className="content-with-sidebar">
                <div className="unidade-header">
                    <div className="d-flex align-items-center gap-3">
                        <button className="btn btn-link text-secondary p-0" onClick={() => navigate('/app/unidadesmedida')} title="Voltar">
                            <i className="fas fa-arrow-left fa-lg"></i>
                        </button>
                        <h1 className="unidade-title m-0">
                            Editar <span className="highlight">Unidade de Medida</span>
                        </h1>
                    </div>
                </div>

                <div className="unidade-content">
                    {mensagem && <div className="alert alert-danger mb-4">{mensagem}</div>}

                    {unidadeData && (
                        <UnidadeMedidaForm
                            initialData={unidadeData}
                            onSubmit={handleSubmit}
                            loading={saving}
                            isEditing={true}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

export default EditarUnidadeMedida;